import React from "react";
import * as Icons from "lucide-react";
import { INDUSTRIES } from "../data/site";

export default function Industries() {
  return (
    <section id="industries" data-testid="industries-section" className="py-20 lg:py-32 bg-[#F7F9FC]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-14">
          <div className="overline mb-4">Industries We Serve</div>
          <h2 className="section-heading text-navy text-3xl md:text-4xl lg:text-5xl font-bold">
            Trusted by buyers across the global grocery value chain.
          </h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 lg:gap-6">
          {INDUSTRIES.map((ind, i) => {
            const Icon = Icons[ind.icon] || Icons.Building2;
            return (
              <div
                key={i}
                data-testid={`industry-card-${i}`}
                className="card-hover bg-white rounded-2xl p-6 lg:p-8 border border-slate-100 text-center"
              >
                <div className="w-14 h-14 mx-auto rounded-2xl flex items-center justify-center bg-emerald/8 text-emerald">
                  <Icon className="w-7 h-7" />
                </div>
                <div className="mt-4 font-semibold text-navy leading-snug">{ind.label}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
